import { apiFactory } from "../api_factory";

const path = "/api/v4/roles";

export const rolesApi = apiFactory({
  path: path
});
